/**
 * @typedef {import('../../types/config/ApplicationEnvironment').APPLICATION_ENVIRONMENT} APPLICATION_ENVIRONMENT
 * @returns {typeof APPLICATION_ENVIRONMENT[keyof typeof APPLICATION_ENVIRONMENT]}
 */
module.exports.getEnvironment = () => {
  return process.env.applicationEnvironment || process.env.APPLICATION_ENVIRONMENT;
};
